<template>
    <div class="container mt-5">

        <router-link class="btn-back" to="/"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page d'accueil</router-link>

        <div class="title">Place de marché </div>
        <div class="highlighted">Solution complète de place de marché pour la vente en ligne de la coopérative sur son territoire incluant un site marchand, application mobile, données clients, formation et sensibilisation, solutions marketing et business modèle local innovant.</div> <br>
            Notre offre de lace de marché en marque blanche vous permet de déployer votre plateforme de vente en ligne digitale sur Web et Mobile pour permettre à vos filiales de gagner en service et en visibilité pour gagner de nouveaux clients.
            <br>

        <div class="highlighted mt-5">Avantages </div>
        <div class="container  text-center">
            
            <div class="row">
                <div class="col-sm-6">
                    <img src="@/assets/img/digital.png" class="mb-3 img-fluid" alt="coopérative digitale Agrivitech">
                    <h3>Coopérative digitale</h3>
                    <p>Le canal digital pour l'offre de la coopérative permettant d’approfondir la connaissance de ses adhérents</p>
                </div>
                <div class="col-sm-6">
                    <img src="@/assets/img/sas.png" class="mb-3 img-fluid" alt="offre sas Agrivitech">
                    <h3>Offre SAS</h3>
                    <p>Une offre par abonnement et un modèle de rémunération de la coopérative</p>
                </div>
                <div class="col-sm-6">
                    <img src="@/assets/img/accompagnement.png" class="mb-3 img-fluid" alt="accompagnement Agrivitech">
                    <h3>Accompagnement</h3>
                    <p>Formation sur mesure pour valoriser les actifs de la coopérative</p>
                </div>
                <div class="col-sm-6">
                    <img src="@/assets/img/avantage.png" class="mb-3 img-fluid" alt="avantage local protégé Agrivitech">
                    <h3>Avantage protégé</h3>
                    <p>Pour une coopérative leader sur son territoire et sur son réseau de commerçants agréés</p>
                </div>
            </div>
        </div>

        <div class="highlighted mt-5">Fonctionnalités </div>
        
        <div class="row featuresList">
            <div class="col-lg-3 col-md-4 col-6">
                Paiement
                <img class="img-fluid" src="../assets/img/Invoice-amico.png" alt="Paiement">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Prix dégressifs
                <img class="img-fluid" src="../assets/img/percentage.png" alt="Prix dégressif">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Multi-vendeurs
                <img class="img-fluid" src="../assets/img/shops.png" alt="Multi shops">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Multi-dépots
                <img class="img-fluid" src="../assets/img/depots.png" alt="Depots">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Livraison
                <img class="img-fluid" src="../assets/img/delivery.png" alt="Livraison">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Personnalisation
                <img class="img-fluid" src="../assets/img/personnalisation.png" alt="Perso">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Equipes commerciales
                <img class="img-fluid" src="../assets/img/team.png" alt="Equipe commerciale terrain">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Bannières programmables
                <img class="img-fluid" src="../assets/img/banner.png" alt="Agrivitech Banners">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Facturation
                <img class="img-fluid" src="../assets/img/invoice.png" alt="Facturation">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Campagnes marketing
                <img class="img-fluid" src="../assets/img/marketing.png" alt="Marketing Agrivitech">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Statistiques
                <img class="img-fluid" src="../assets/img/stats.png" alt="Statistiques">
            </div>
            <div class="col-lg-3 col-md-4 col-6">
                Multi-canal
                <img class="img-fluid" src="../assets/img/multicanal.png" alt="Multi canaux">
            </div>
        </div>


        <div class="row mt-5 mb-5 text-center">
            <!-- <a class="btn btn-secondary-outline ml-auto" href="">En savoir plus</a> -->
            <router-link class="btn btn-primary mx-auto" to="/contact-demo"> Demander une démo</router-link>
        </div>


        <div class="title">Exemples clients</div>
        <div class="highlighted">Nos places de marché en ligne </div>
            <div class="row clients-logo text-center mb-5">
            <div class="col-lg-5 logoContainer mx-auto"><router-link class="nav-link" to="/solutions/marketplace/avm"><img class="img-fluid" src="../assets/img/viticulteursLogo.png" alt=""></router-link></div>
            <div class="col-lg-5 logoContainer mx-auto"><router-link class="nav-link" to="/solutions/marketplace/dtj"><img class="img-fluid" src="../assets/img/danstonjardin.png" alt=""></router-link></div>
        </div>

  

        <MailjetNewsLetter/>

    </div>
    
</template>

<script>

import MailjetNewsLetter from '../components/MailjetNewsLetter'


export default {
    name: 'Marketplace',
    components:{
            MailjetNewsLetter
        },
    methods:{
         
    }
}
</script>

<style lang="scss" scoped>


    .featuresList{
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        img{
            padding: 5px;
            margin-bottom: 40px;
        }
    }

    .poductLink{
        background-color: white;
        border: var(--mainBlue) 10px solid;
        border-radius: 20px;
        padding: 30px;
        text-align: center;
    }

     .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }


</style>